<template>
  <vs-input v-if="readonly" v-model="data" style="color: red;" readonly class="w-full flex-1" />
  <multiselect
    v-else-if="multiple"
    :options="disasterList"
    v-model="data"
    :multiple="true"
    placeholder=""
  />
  <vs-select
    v-else
    v-model="data"
    autocomplete
    :disabled="disabled || readonly"
    class="red-text disaster"
  >
    <vs-select-item v-for="disaster in disasterList" :key="disaster" :value="disaster" :text="disaster" />
  </vs-select>
</template>

<script>
import { disasters } from "@/util/DisasterDataUtil.js";
import Multiselect from 'vue-multiselect'
export default {
  name: "DisasterClassSelector",
  components: {
    Multiselect
  },
  props: {
    value: String | Array,
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
  },
  data() {
    return {
      disasterList: disasters,
      data: this.value,
      selected: '',
    };
  },
  watch: {
    value() {
      this.data = this.value;
    },
    data(/*value*/) {
      this.$emit("input", this.data);
    },
  },
  mounted() {
    if (!this.value && !this.multiple) {
      this.data = "넘어짐";
      this.$emit("input", this.data);
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.red-text.disaster input {
  color: red;
}
</style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary),1)!important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97)
    }
    border-color: #cdcdcd !important;
  }
}
</style>
